import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
    name: "schedules",
    initialState: {
        list: [],
        loading: true,
        saveLoading: false,
        lastFetch: null,
        addedStatus:false,
        deletedStatus:false,
        updatedStatus:false,
    },
    reducers: {
        scheduleRequestStarted: (schedules) => {
            schedules.loading = true;
            schedules.list = [];
            schedules.addedStatus = false;
            schedules.deletedStatus = false;
            schedules.updatedStatus = false;
        },
        scheduleRequestFailed: (schedules) => {
            schedules.loading = false;
        },
        scheduleSaveStarted: (schedules) => {
            schedules.saveLoading = true;
            schedules.addedStatus = false;
            schedules.deletedStatus = false;
            schedules.updatedStatus = false;
        },
        scheduleSaveFailed: (schedules) => {
            schedules.saveLoading = false;
        },
        appSchedulesReceived:(schedules,action)=>{
            schedules.list=action.payload;
            schedules.addedStatus=false;
            schedules.deletedStatus=false;
            schedules.loading = false;
        },
        appScheduleAdded:(schedules,action)=>{
            schedules.addedStatus=true;
            schedules.loading = false;
            schedules.saveLoading = false;
        },
        scheduleDeleted:(schedules,action)=>{
            schedules.deletedStatus=true;
            schedules.loading = false;
        },
        scheduleUpdated:(schedules,action)=>{
            schedules.updatedStatus=true;
            schedules.loading = false;
            schedules.saveLoading = false;
        },
        
    }
});

export const { scheduleRequestStarted, scheduleRequestFailed, appSchedulesReceived,appScheduleAdded,
    scheduleDeleted,scheduleUpdated, scheduleSaveStarted, scheduleSaveFailed } = slice.actions;
export default slice.reducer;

export const loadAppSchedules = (id) => apiCallBegan({
    url: config.GetScheduleMeeting + id,
    onStart: { type: scheduleRequestStarted.type },
    onError: { type: scheduleRequestFailed.type },
    onSuccess: appSchedulesReceived.type
});

export const addAppSchedule = (data) => apiCallBegan({
    url: config.AddMeetingSchedule,
    method:"post",
    data:data,
    onStart: { type: scheduleSaveStarted.type },
    onError: { type: scheduleSaveFailed.type },
    onSuccess: appScheduleAdded.type
});

export const updateAppSchedule = (data) => apiCallBegan({
    url: config.UpdateAppointment,
    method:"post",
    data:data,
    onStart: { type: scheduleSaveStarted.type },
    onError: { type: scheduleSaveFailed.type },
    onSuccess: scheduleUpdated.type
});

export const deleteAppSchedule = (data) => apiCallBegan({
    url: config.DeleteAppointment,
    method:"post",
    data:data,
    onStart: { type: scheduleRequestStarted.type },
    onError: { type: scheduleRequestFailed.type },
    onSuccess: scheduleDeleted.type
});

export const getAppSchedules = createSelector(
    state => state.entities.schedules,
    schedules => schedules.list
);

export const getAppScheduleLoading = createSelector(
    state => state.entities.schedules,
    schedules => schedules.loading
);

export const getAppScheduleSaveLoading = createSelector(
    state => state.entities.schedules,
    schedules => schedules.saveLoading
);

export const getAppScheduleAddedStatus = createSelector(
    state => state.entities.schedules,
    schedules => schedules.addedStatus
);

export const getAppScheduleDeletedStatus = createSelector(
    state => state.entities.schedules,
    schedules => schedules.deletedStatus
);

export const getAppScheduleUpdatedStatus = createSelector(
    state => state.entities.schedules,
    schedules => schedules.updatedStatus
);

